/*!
 * Black Dashboard PRO React - v1.0.0
 * Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
 * Copyright 2019 Creative Tim (https://www.creative-tim.com)
 * Coded by Creative Tim
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */
import React from 'react';
import ReactWizard from 'react-bootstrap-wizard';
import { Col, Modal, ModalHeader } from 'reactstrap';
import axios from 'axios';

import * as user_urls from '../../urls/api-users/merchant';

import Step1 from './WizardSteps/SubMerchant_Step1';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

var steps = [
  {
    stepName: 'Account',
    stepIcon: 'tim-icons icon-single-02',
    component: Step1
  }
];

class CreateSubMerchantWizard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      submitError: null
    };
    this.finishButtonClick = this.finishButtonClick.bind(this);
  }

  extractErrorMessage = error => {
    const responseData = error && error.response ? error.response.data : null;

    if (responseData && responseData.message) {
      if (typeof responseData.message === 'string' && responseData.message.trim() !== '') {
        return responseData.message.trim();
      }

      if (typeof responseData.message === 'object' && typeof responseData.message.message === 'string' && responseData.message.message.trim() !== '') {
        return responseData.message.message.trim();
      }
    }

    if (responseData && typeof responseData.error === 'string' && responseData.error.trim() !== '') {
      return responseData.error.trim();
    }

    if (error && error.message) {
      return error.message;
    }

    return 'Unable to create the user account.';
  };

  extractErrorDetails = error => {
    const responseData = error && error.response ? error.response.data : null;
    const details = [];

    if (responseData) {
      if (Array.isArray(responseData.details)) {
        details.push(...responseData.details.filter(Boolean));
      }

      if (Array.isArray(responseData.debugMessageList)) {
        details.push(...responseData.debugMessageList.filter(Boolean));
      }

      if (responseData.message && typeof responseData.message === 'object' && Array.isArray(responseData.message.details)) {
        details.push(...responseData.message.details.filter(Boolean));
      }
    }

    return [...new Set(details.map(detail => String(detail).trim()).filter(Boolean))];
  };

  finishButtonClick(allStates) {
    const createStoreManagerUrl = user_urls.createSubMerchant + this.props.storeId + '/create/store-manager';
    const createInventoryManagerUrl = user_urls.createSubMerchant + this.props.storeId + '/create/inventory-manager';
    const createPickerUrl = user_urls.createSubMerchant + this.props.storeId + '/create/picker';
    var merchant = {
      firstname: allStates.Account.firstname,
      lastname: allStates.Account.lastname,
      username: allStates.Account.username,
      email: allStates.Account.email,
      phone_number: allStates.Account.phone.replace(/\D/g, ''),
      password: allStates.Account.password
    };

    this.setState({ loading: true, submitError: null });

    axios({
      method: 'post',
      url: allStates.Account.selectedRole.val === '220' ? createStoreManagerUrl : allStates.Account.selectedRole.val === '230' ? createInventoryManagerUrl : createPickerUrl,
      withCredentials: true,
      data: merchant,
      headers: { 'content-type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('access_token') }
    })
      .then(response => {
        if (response.status === 200) {
          this.setState({ loading: false, submitError: null }, () => {
            this.props.notify('Successfully added Account');
            this.props.toggleDropdown();
          });
        } else {
          this.setState({ loading: false }, () => {
            this.props.notify(response.error.message);
          });
        }
      })
      .catch(error => {
        const message = this.extractErrorMessage(error);
        const details = this.extractErrorDetails(error);

        this.setState({ loading: false }, () => {
          this.setState({
            submitError: {
              message,
              details
            }
          });
          this.props.notify(message);
        });
      });
  }
  render() {
    return (
      <>
        <div className="content" style={{ paddingTop: 20 }}>
          <Col className="mr-auto ml-auto" md="10">
            {this.state.submitError && (
              <div
                style={{
                  marginBottom: 20,
                  borderRadius: 12,
                  padding: '14px 16px',
                  background: 'rgba(190, 30, 45, 0.14)',
                  border: '1px solid rgba(190, 30, 45, 0.35)',
                  color: '#ffffff'
                }}
              >
                <div style={{ fontWeight: 700, marginBottom: this.state.submitError.details.length > 0 ? 8 : 0 }}>Create user failed: {this.state.submitError.message}</div>
                {this.state.submitError.details.length > 0 && (
                  <ul style={{ margin: 0, paddingLeft: 18, color: 'rgba(255, 255, 255, 0.85)' }}>
                    {this.state.submitError.details.map(detail => (
                      <li key={detail}>{detail}</li>
                    ))}
                  </ul>
                )}
              </div>
            )}
            <ReactWizard
              steps={steps}
              navSteps
              validate
              title="Create a new account"
              headerTextCenter
              finishButtonClasses="btn-wd btn-info"
              nextButtonClasses="btn-wd btn-info"
              previousButtonClasses="btn-wd"
              progressbar
              color="blue"
              finishButtonClick={this.finishButtonClick}
            />
          </Col>
        </div>
        <Modal isOpen={this.state.loading} centered={true}>
          <div style={{ padding: 50, textAlign: 'center' }}>
            <ModalHeader style={{ justifyContent: 'center' }}>
              <div style={{ color: 'black', fontSize: '1.75rem', fontWeight: 600 }}>Please wait...</div>
            </ModalHeader>
            <Loader type="TailSpin" color="#00BFFF" height={100} width={100} />
          </div>
        </Modal>
      </>
    );
  }
}

export default CreateSubMerchantWizard;
